<template>
    <div>
        <div class="flex flex-col h-screen max-w-7xl mx-auto">
            <header class="pl-12 pt-6">
                <Logo />
            </header>
            <div class="grid md:grid-cols-2 pt-6 flex-1">
                <div class="pl-12 max-w-lg">
                    <h2 class="ds-login-welcome hidden lg:block">{{ $t('welcome') }}</h2>
                </div>
                <div class="pr-24 pb-10 flex justify-end items-center">
                    <slot />
                </div>
            </div>
            <footer class="mt-auto relative">
                <div class="ds-login-footer mx-auto text-center pt-11 pb-11">Powered by MindM v. 2.0</div>
            </footer>
        </div>
        <icon width="50" height="69" class="absolute left-0 bottom-10"><icon-cat></icon-cat></icon>
    </div>
</template>

<script setup lang="ts">
import IconCat from '../ui/icons/IconCat.vue'

</script>
